import React, { useRef } from 'react';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { get } from 'lodash';
import classNames from 'classnames';

export const FormInputFieldType = {
  TEXT: 'text',
  NUMBER: 'number',
  DATE: 'date',
  TIME: 'time',
  PASSWORD: 'password',
  TEXTAREA: 'textarea',
};

function FormInputFieldInner(props) {
  let ref = useRef(null);
  const {
    label,
    placeholder,
    type,
    form,
    field,
    noStyling = false,
    disabled = false,
    style,
    setRef,
    upperCase,
    inputClassName,
    required = false,
    maxLength,
  } = props;
  const error = get(form.errors, field.name);
  const touched = get(form.touched, field.name);
  const value = get(form.values, field.name, '');
  const renderValue = (valueToRender) => {
    if (upperCase && typeof valueToRender === 'string') {
      return valueToRender.toUpperCase();
    }
    return valueToRender;
  };

  const element = (
    <>
      <Input
        className={inputClassName}
        style={style}
        placeholder={placeholder}
        type={type}
        value={renderValue(value)}
        disabled={form.isSubmitting || disabled}
        maxLength={maxLength}
        onBlur={() => form.setFieldTouched(field.name, true)}
        onChange={({ target }) => {
          form.setFieldValue(field.name, target.value);
        }}
        innerRef={(input) => {
          if (setRef) {
            ref = input;
            setRef(ref);
          }
        }}
      />
      {(form.submitCount > 0 || touched) && error && (
        <label
          style={{
            fontSize: 13,
            fontWeight: 400,
            color: 'red',
            marginTop: '6px',
            letterSpacing: '0.02rem',
          }}
        >
          {error}
        </label>
      )}
    </>
  );

  return noStyling ? (
    element
  ) : (
    <Row>
      <Col>
        <Label className={classNames(required && 'label-required')}>{label}</Label>
        <FormGroup
          className={classNames((form.submitCount > 0 || touched) && error && 'field-error')}
        >
          {element}
        </FormGroup>
      </Col>
    </Row>
  );
}

function FormInputField(props) {
  return <Field {...props} component={FormInputFieldInner} />;
}

FormInputField.defaultProps = {
  label: '',
  style: null,
  type: FormInputFieldType.TEXT,
  placeholder: '',
  disabled: false,
  setRef: null,
  upperCase: false,
  inputClassName: '',
  maxLength: undefined,
};

FormInputField.propTypes = {
  label: PropTypes.string,
  style: PropTypes.object,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  setRef: PropTypes.func,
  upperCase: PropTypes.bool,
  inputClassName: PropTypes.string,
  maxLength: PropTypes.number,
};

export default FormInputField;
